<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "app",
  computed: {
    ...mapGetters({
      user: "user/user"
    }),
    nextRoute() {
      return this.$route.query.redirect || "/";
    }
  },
  watch: {
    user(auth) {
      if (
        auth &&
        !this.$route.path.includes("/sessions") &&
        this.$route.path !== "/refresh-account-link"
      ) {
        this.$router.replace(this.nextRoute);
      }
    },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("SETUP_URL_SETTINGS", query);
    }
  }
};
</script>

<style lang="scss">
@import url("./assets/styles/main.scss");
// @import "assets/styles/main";
</style>
